import {
  isAnnouncementFormValues,
  isResearchFormValues,
  MailingObjectivesFormPayloadWithoutFiles,
  MailingObjectivesFormType,
  ObjectivesFormDocumentFile,
} from '@mailings/components/creators/personalized-mailing-creator-wizard/types/mailingObjectivesForm.types';
import { SerializedFile, serializedFileSchema } from '@mailings/types/mailings.types';
import { removeNullableKeys } from '@src/utils/removeNullableKeys';

export const buildPayloadWithoutFiles = (
  formValues: MailingObjectivesFormType,
): MailingObjectivesFormPayloadWithoutFiles => {
  if (isAnnouncementFormValues(formValues) || isResearchFormValues(formValues)) {
    const { storyDocumentFile: _storyDocumentFile, ...rest } = formValues;
    return removeNullableKeys(rest);
  }

  return removeNullableKeys(formValues);
};

export function isSerializedFormFile(
  value: ObjectivesFormDocumentFile | undefined,
): value is SerializedFile {
  if (value === null || value === undefined) {
    return false;
  }

  if (value instanceof File) {
    return false;
  }

  return serializedFileSchema.safeParse(value).success;
}
